class BpHeroSlideshow {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.bp-hero__track');
    this.slides = Array.from(section.querySelectorAll('.bp-hero__slide'));
    this.dots = Array.from(section.querySelectorAll('.bp-hero__dot'));
    this.counter = section.querySelector('.bp-hero__counter');
    this.prevBtn = section.querySelector('.bp-hero__arrow--prev');
    this.nextBtn = section.querySelector('.bp-hero__arrow--next');

    this.current = 0;
    this.paused = false;
    this.timer = null;
    this.touchStartX = null;
    this.touchStartY = null;
    this.speed = (parseInt(this.track.dataset.autoplaySpeed, 10) || 7) * 1000;

    this.init();
  }

  init() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
    this.dots.forEach((dot) =>
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)))
    );

    this.section.addEventListener('mouseenter', () => {
      this.paused = true;
    });
    this.section.addEventListener('mouseleave', () => {
      this.paused = false;
      this.schedule();
    });

    this.section.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
      this.paused = true;
    }, { passive: true });

    this.section.addEventListener('touchend', (e) => {
      if (this.touchStartX === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - this.touchStartX;
      const dy = t.clientY - this.touchStartY;
      this.touchStartX = null;
      this.touchStartY = null;
      this.paused = false;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        dx < 0 ? this.next() : this.prev();
      } else {
        this.schedule();
      }
    }, { passive: true });

    this.schedule();
  }

  goTo(index) {
    const prev = this.current;
    this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;

    // Deactivate previous
    this.slides[prev].classList.remove('is-active');
    this.slides[prev].setAttribute('aria-hidden', 'true');
    this.dots[prev]?.classList.remove('is-active');
    this.dots[prev]?.setAttribute('aria-selected', 'false');

    // Reset ken-burns on new active slide image so it restarts
    const img = this.slides[this.current].querySelector('.bp-hero__img');
    if (img) {
      img.style.animation = 'none';
      void img.offsetHeight; // force reflow
      img.style.animation = '';
    }

    // Activate new
    this.slides[this.current].classList.add('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'false');
    this.dots[this.current]?.classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'true');

    // Update counter
    if (this.counter) {
      const n = String(this.current + 1).padStart(2, '0');
      const total = String(this.slides.length).padStart(2, '0');
      this.counter.textContent = `${n} / ${total}`;
    }

    clearTimeout(this.timer);
    this.schedule();
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  schedule() {
    clearTimeout(this.timer);
    if (this.paused || this.slides.length <= 1) return;
    this.timer = setTimeout(() => this.next(), this.speed);
  }

  destroy() {
    clearTimeout(this.timer);
  }
}

// Init on load
const heroSections = document.querySelectorAll('.bp-hero');
const heroInstances = [];
heroSections.forEach((section) => {
  if (section.querySelector('.bp-hero__slide')) {
    heroInstances.push(new BpHeroSlideshow(section));
  }
});

// Shopify theme editor: reinit on section reload
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.bp-hero');
  if (section) heroInstances.push(new BpHeroSlideshow(section));
});

document.addEventListener('shopify:section:unload', () => {
  heroInstances.forEach((i) => i.destroy());
});
